module.exports = __webpack_public_path__ + "static/media/login-bg2.e3df4b1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/login-bg2.jpg
// module id = 170
// module chunks = 0